import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["editButton", "dropdown"];

  connect() {
    this.hideDropdown();
  }

  toggle() {
    if (this.dropdownTarget.classList.contains("hidden")) {
      this.showDropdown();
    } else {
      this.hideDropdown();
    }
  }

  showDropdown() {
    this.dropdownTarget.classList.remove("hidden");
    this.dropdownTarget.classList.add("animate-fade-in");
    this.editButtonTarget.classList.add("text-primary");
  }

  hideDropdown() {
    this.dropdownTarget.classList.add("hidden");
    this.dropdownTarget.classList.remove("animate-fade-in");
    this.editButtonTarget.classList.remove("text-primary");
  }

  // Hide dropdown when clicking outside
  windowClick(event) {
    if (!this.element.contains(event.target)) {
      this.hideDropdown();
    }
  }

  // Hide dropdown after form submission
  formSubmitted() {
    this.hideDropdown();
  }
}
